import { Injectable } from '@angular/core';
import { AbstractControlOptions, UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { InvestmentKnowledge3 } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: InvestmentKnowledge3 & { riskProfil: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<InvestmentKnowledge3 & { riskProfil: any }> = {
      ownerId: [entity.ownerId],
      userFirstName: [entity.userFirstName],
      userLastName: [entity.userLastName],
      // indexFund1: [entity && entity.indexFund1 ? entity.indexFund1 : "UNKNOWN"],
      // indexFund2: [entity && entity.indexFund2 ? entity.indexFund2 : "UNKNOWN"],
      // derivativeProducts1: [
      //   entity && entity.derivativeProducts1
      //     ? entity.derivativeProducts1
      //     : "UNKNOWN",
      // ],
      // derivativeProducts2: [
      //   entity && entity.derivativeProducts2
      //     ? entity.derivativeProducts2
      //     : "UNKNOWN",
      // ],
      riskProfil: this.formBuilder.group({
        indexFund1: [entity?.riskProfil?.indexFund1 || 'UNKNOWN'],
        indexFund2: [entity?.riskProfil?.indexFund2 || 'UNKNOWN'],
        derivativeProducts1: [
          entity?.riskProfil?.derivativeProducts1 || 'UNKNOWN',
        ],
        derivativeProducts2: [
          entity?.riskProfil?.derivativeProducts2 || 'UNKNOWN',
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: InvestmentKnowledge3[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
